module.exports = __webpack_public_path__ + "img/jn.7763bf36.png";